((Drupal, $, once) => {

  /**
   * Activate collapsible control for multi column.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.gliCollapsibleControl = {
    attach(context, settings) {
      const collapsibleSections = once('gli-collapsible-control', '.collapsible-control-wrapper');
      collapsibleSections.forEach(section => {
        // Collapse all but the first 3 items.
        const collapsibleArea = section.querySelector('.collapsible-area');
        // @todo Remove dependence on jQuery.
        $(collapsibleArea).hide();

        const cta = section.querySelector('.multi-column-cta a');
        if (cta && cta.textContent.indexOf('Explore all') == -1) {
          cta.textContent = cta.getAttribute('data-expand-label');
        }

        // On click, toggle collapse.
        cta.addEventListener('click', event => {
          event.preventDefault();
          if ($(collapsibleArea).is(':hidden')) {
            // Expand.
            $(collapsibleArea).slideDown();
            cta.textContent = cta.getAttribute('data-collapse-label');
          }
          else {
            // Collapse.
            $(collapsibleArea).slideUp();
            cta.textContent = cta.getAttribute('data-expand-label');
          }
        });
      });
    }
  };

})(Drupal, jQuery, once);
